document.addEventListener('DOMContentLoaded', () => {
  // --- elementos
  const $form = document.getElementById('kitSelectorV2');
  const $sup = document.getElementById('sc-superficie');
  const $espWrap = document.getElementById('sc-wrap-espacio');
  const $esp = document.getElementById('sc-espacio');
  const $supor = document.getElementById('sc-soporte');
  const $m2 = document.getElementById('sc-m2');
  const $btn = document.getElementById('sc-submit');
  const $reset = document.getElementById('sc-reset');
  const $hint = document.getElementById('sc-hint');

  // --- opciones propuestas
  const SUPERFICIES = ['paredes','suelos','escaleras','encimeras','lavabos','duchas','mesas','muebles','chimeneas'];
  const ESPACIOS = ['cocina','baño','otro'];
  const SOPORTES = [
    { value: 'azulejos',   label: 'Azulejos / Gresite (no absorbente)' },
    { value: 'azulejos',label: 'Porcelánicos / Mármol (no absorbente)' },
    { value: 'cemento',    label: 'Cemento / Hormigón (absorbente)' },
    { value: 'cemento',     label: 'Pladur / Yeso (absorbente)' }
  ];
  // Solo tamaños realmente disponibles en tu catálogo
  const M2_ALL = [4,8,16,24];

  // --- util
  const opt = (v,l)=>{const o=document.createElement('option');o.value=v;o.textContent=l;return o;};
  const fill = (sel, arr, ph) => { 
    sel.innerHTML=''; 
    const phOpt=opt('', ph||'Elige...'); 
    phOpt.disabled=true; phOpt.selected=true; 
    sel.appendChild(phOpt); 
    arr.forEach(x=>sel.appendChild(opt(x.value??x, x.label??x))); 
  };
  const uniq = arr => Array.from(new Set(arr));

  // --- DATA estático (tus URLs de producto)
  const DATA = [
    // PAREDES baño con juntas (azulejos)
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-con-juntas-de-4-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-con-juntas-de-8-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'azulejos', m2: 16, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-con-juntas-de-16-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'azulejos', m2: 24, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-con-juntas-de-24-m' },

    // PAREDES baño sin juntas (cemento)
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-banos-de-obra-de-4-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-banos-de-obra-de-8-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'cemento', m2: 16, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-de-obra-de-16-m' },
    { superficie: 'paredes', espacio: 'baño', soporteGroup: 'cemento', m2: 24, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-paredes-de-bano-de-obra-de-24-m' },

    // PAREDES cocina con juntas (azulejos)
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-con-juntas-de-4-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-con-juntas-de-8-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'azulejos', m2: 16, url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-con-juntas-de-16-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'azulejos', m2: 24, url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-con-juntas-de-24-m' },

    // PAREDES cocina sin juntas (cemento)
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-de-obra-de-4-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-de-obra-de-8-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'cemento', m2: 16, url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-de-obra-de-16-m' },
    { superficie: 'paredes', espacio: 'cocina', soporteGroup: 'cemento', m2: 24, url: 'https://www.smartcret.com/products/kit-microcemento-para-paredes-de-cocina-de-obra-de-24-m' },

    // PAREDES otros espacios
    { superficie: 'paredes', espacio: 'otro', m2: 6,  url: 'https://www.smartcret.com/products/mini-kit-de-microcemento-para-paredes-de-6-m' },
    { superficie: 'paredes', espacio: 'otro', m2: 12,  url: 'https://www.smartcret.com/products/smart-kit-de-microcemento-para-paredes-de-12-m' },
    { superficie: 'paredes', espacio: 'otro', m2: 18, url: 'https://www.smartcret.com/products/super-kit-de-microcemento-para-paredes-de-18-m' },
    { superficie: 'paredes', espacio: 'otro', m2: 24, url: 'https://www.smartcret.com/products/mega-kit-de-microcemento-para-paredes-de-24-m' },

    // SUELOS baño con juntas (azulejos)
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-bano-con-juntas-4m' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-bano-con-juntas-8m' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'azulejos', m2: 16, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-bano-con-juntas-16m' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'azulejos', m2: 24, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-bano-con-juntas-24m' },

    // SUELOS baño de obra (cemento)
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-microcemento-para-suelo-de-bano-de-4-m-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-microcemento-para-suelo-de-bano-de-8-m-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'cemento', m2: 16, url: 'https://www.smartcret.com/products/kit-microcemento-para-suelo-de-bano-de-16-m-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'baño', soporteGroup: 'cemento', m2: 24, url: 'https://www.smartcret.com/products/kit-microcemento-para-suelo-de-bano-de-24-m-superficies-absorbentes' },

    // SUELOS cocina con juntas (azulejos)
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-cocina-con-juntas-de-4m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-cocina-con-juntas-de-8m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 16, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-cocina-con-juntas-de-16m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 24, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-cocina-con-juntas-de-24m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 48, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelos-de-cocina-para-48-m-con-juntas' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'azulejos', m2: 96, url: 'https://www.smartcret.com/products/kit-microcemento-para-suelos-de-cocina-para-96-m-superficies-con-juntas' },

    // SUELOS cocina de obra (cemento)
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelo-de-cocina-de-obra-para-4-m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelo-de-cocina-de-obra-para-8-m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 16, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelo-de-cocina-de-obra-para-16-m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 24, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-suelo-de-cocina-de-obra-para-24-m' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 48, url: 'https://www.smartcret.com/products/kit-microcemento-para-suelos-de-cocinas-para-48-m-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'cocina', soporteGroup: 'cemento', m2: 48, url: 'https://www.smartcret.com/products/kit-microcemento-para-suelos-de-cocinas-de-96-m-superficies-absorbentes' },

    // SUELOS otros espacios con juntas (azulejos)
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/mini-kit-de-microcemento-para-banos-duchas-y-cocinas-para-4-m-de-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/smart-kit-de-microcemento-para-banos-duchas-y-cocinas-para-8-m-de-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'azulejos', m2: 16, url: 'https://www.smartcret.com/products/super-kit-de-microcemento-para-banos-duchas-y-cocinas-para-16-m-de-superficies-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'azulejos', m2: 24, url: 'https://www.smartcret.com/products/mega-kit-de-microcemento-para-banos-duchas-y-cocinas-para-24-m-de-superficies-absorbentes' },

    // SUELOS otros espacios sin juntas (cemento)
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/mini-kit-de-microcemento-para-banos-duchas-y-cocinas-para-4-m-de-superficies-no-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/smart-kit-de-microcemento-para-banos-duchas-y-cocinas-para-8-m-de-superficies-no-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'cemento', m2: 16, url: 'https://www.smartcret.com/products/super-kit-de-microcemento-para-banos-duchas-y-cocinas-para-16-m-de-superficies-no-absorbentes' },
    { superficie: 'suelos', espacio: 'otro', soporteGroup: 'cemento', m2: 24, url: 'https://www.smartcret.com/products/mega-kit-de-microcemento-para-banos-duchas-y-cocinas-para-24-m-de-superficies-no-absorbentes' },

    // ESCALERAS con juntas (azulejos)
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-escaleras-de-azulejos-de-4-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-escaleras-de-azulejos-de-8-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'azulejos', m2: 16,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-escaleras-de-azulejos-de-16-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'azulejos', m2: 24,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-escalera-de-azulejos-para-24-m' },

    // ESCALERAS de obra (cemento)
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-microcemento-para-escaleras-de-obra-de-4-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-microcemento-para-escaleras-de-obra-de-8-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'cemento', m2: 16,  url: 'https://www.smartcret.com/products/kit-microcemento-para-escaleras-de-obra-de-16-m' },
    { superficie: 'escaleras', espacio: 'otro', soporteGroup: 'cemento', m2: 24,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-escaleras-de-obra-para-24-m' },

    // ENCIMERAS con juntas (azulejos)
    { superficie: 'encimeras', espacio: 'otro', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-encimeras-con-juntas-4-m' },
    { superficie: 'encimeras', espacio: 'otro', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-encimeras-con-juntas-de-8m' },

    // ENCIMERAS de obra (cemento)
    { superficie: 'encimeras', espacio: 'otro', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-encimeras-de-obra-de-4m' },
    { superficie: 'encimeras', espacio: 'otro', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-encimera-de-obra-de-8m' },

    // LAVABOS de obra (cemento)
    { superficie: 'lavabos', espacio: 'otro', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-lavabos-de-obra-de-4m' },
    { superficie: 'lavabos', espacio: 'otro', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-lavabos-de-obra-de-8m' },

    // LAVABOS con juntas (azulejos)
    { superficie: 'lavabos', espacio: 'otro', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-lavabos-con-juntas-4-m' },
    { superficie: 'lavabos', espacio: 'otro', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-lavabos-con-juntas-de-8m' },

    // DUCHAS azulejos / gresite
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'azulejos', m2: 4,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-duchas-con-juntas-de-4-m' },
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'azulejos', m2: 8,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-duchas-con-juntas-de-8-m' },
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'azulejos', m2: 16,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-duchas-con-juntas-de-16-m' },

    // DUCHAS cemento / hormigón
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'cemento', m2: 4,  url: 'https://www.smartcret.com/products/kit-microcemento-para-duchas-de-obra-de-4-m' },
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'cemento', m2: 8,  url: 'https://www.smartcret.com/products/kit-microcemento-para-duchas-de-obra-de-8-m' },
    { superficie: 'duchas', espacio: 'baño', soporteGroup: 'cemento', m2: 16,  url: 'https://www.smartcret.com/products/kit-microcemento-para-duchas-de-obra-de-16-m' },

    // MESAS (sin soporte)
    { superficie: 'mesas', espacio: 'otro', m2: 6,  url: 'https://www.smartcret.com/products/kit-microcemento-mesas-6m' },
    { superficie: 'mesas', espacio: 'otro', m2: 12, url: 'https://www.smartcret.com/products/kit-microcemento-mesas-12m' },

    // MUEBLES (sin soporte)
    { superficie: 'muebles', espacio: 'otro', m2: 6,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-muebles-de-6-m' },
    { superficie: 'muebles', espacio: 'otro', m2: 12, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-muebles-de-12-m' },

    // CHIMENEAS cemento / hormigón
    { superficie: 'chimeneas', espacio: 'otro', soporteGroup: 'cemento', m2: 6,  url: 'https://www.smartcret.com/products/kit-de-microcemento-para-chimenea-de-obra-6-m' },
    { superficie: 'chimeneas', espacio: 'otro', soporteGroup: 'cemento', m2: 12, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-chimenea-de-obra-para-12-m' },
    { superficie: 'chimeneas', espacio: 'otro', soporteGroup: 'cemento', m2: 18, url: 'https://www.smartcret.com/products/kit-de-microcemento-para-chimenea-de-obra-para-18-m' }
  ];

   // === NUEVO: regla de soporte requerido ===
  const isSoporteRequired = () => {
    const selSup = $sup.value;
    const selEsp = $esp.value || null;  

    if ((selSup === 'paredes' && selEsp === 'otro') ||
        selSup === 'mesas' ||
        selSup === 'muebles') {
      return false;
    }
    return true;
  };

  // --- poblar selects iniciales
  fill($sup, SUPERFICIES, 'Elige superficie');

  const updateEspacio = () => {
    const selSup = $sup.value;

    if (!selSup) {
      // todavía no hay superficie elegida → placeholder y bloqueado
      fill($esp, [], 'Elige espacio');
      $esp.disabled = true;
      return;
    }

    if (selSup === 'paredes' || selSup === 'suelos') {
      fill($esp, ESPACIOS, 'Elige espacio');
      $esp.disabled = false;
    } else {
      fill($esp, [], 'No requiere espacio');
      $esp.disabled = true;
    }
  };

const updateSoporte = () => {
  const selSup = $sup.value;
  const selEsp = $esp.disabled ? null : $esp.value || null;

  if (!selSup) {
    fill($supor, [], 'Elige soporte');
    $supor.disabled = true;
    return;
  }

  // Caso especial: Paredes + otros espacios → no requiere soporte
  if ((selSup === 'paredes' && selEsp === 'otro') ||
      selSup === 'mesas' ||
      selSup === 'muebles') {
    fill($supor, [], 'No requiere soporte');
    $supor.disabled = true;
    return;
  }

  // En cualquier otro caso, calcular opciones
  $supor.disabled = false;
  const possible = DATA
    .filter(x => x.superficie === selSup && (selEsp ? (x.espacio === selEsp || x.espacio === 'otro') : true))
    .map(x => x.soporteGroup).filter(Boolean);

  const list = possible.length ? SOPORTES.filter(s => possible.includes(s.value)) : SOPORTES;
  fill($supor, list, 'Elige soporte');
};


  const updateM2 = () => {
  const selSup = $sup.value;
  if (!selSup) {
    fill($m2, [], 'Elige m²');
    $m2.disabled = true;
    return;
  }

  const selEsp = $esp.disabled ? null : $esp.value || null;
  const selSupor = $supor.disabled ? '' : $supor.value;

  const metros = uniq(
    DATA.filter(x =>
      x.superficie === selSup &&
      (selEsp ? (x.espacio === selEsp || x.espacio === 'otro') : true) &&
      (selSupor ? x.soporteGroup === selSupor : true)
    ).map(x => x.m2)
  ).sort((a,b)=>a-b);

  const source = metros.length ? metros : M2_ALL;
  fill($m2, source.map(n => ({value:String(n), label:`Hasta ${n} m²`})), 'Elige m²');
  $m2.disabled = false;
};


  const validate = () => {
    $hint.hidden = true;
    const needsSupor = isSoporteRequired();          
    const soporteOk = needsSupor ? !!$supor.value : true;
    const ready = $sup.value && soporteOk && $m2.value && ($esp.disabled || $esp.value);

    // 🔍 DEPURACIÓN
    console.log("=== VALIDATE ===");
    console.log("Superficie:", $sup.value);
    console.log("Espacio (value):", $esp.value, "| disabled:", $esp.disabled);
    console.log("Soporte requerido:", needsSupor);
    console.log("Soporte value:", $supor.value, "| soporteOk:", soporteOk, "| disabled:", $supor.disabled);
    console.log("m2 value:", $m2.value);
    console.log("Ready:", ready);

    $btn.disabled = !ready;
    $btn.setAttribute('aria-disabled', String(!ready));
  };


  // --- listeners
  $sup.addEventListener('change', () => { updateEspacio(); updateSoporte(); updateM2(); validate(); });
  $esp.addEventListener('change', () => { updateSoporte(); updateM2(); validate(); });
  $supor.addEventListener('change', () => { updateM2(); validate(); });
  $m2.addEventListener('change', validate);

  $reset.addEventListener('click', () => {
  fill($sup, SUPERFICIES, 'Elige superficie');
  fill($esp, [], 'Elige espacio'); $esp.disabled = true;
  fill($supor, [], 'Elige soporte'); $supor.disabled = true;
  fill($m2, [], 'Elige m²'); $m2.disabled = true;

  $btn.disabled = true; 
  $btn.setAttribute('aria-disabled','true');
  $hint.hidden = true;
  $form.reset();
});


  // --- envío: ir a la URL del kit coincidente
  $form.addEventListener('submit', e => {
    e.preventDefault();
    const selSup = $sup.value;
    const selEsp = $espWrap.hidden ? null : $esp.value || 'otro';
    const needsSupor = isSoporteRequired();          // === CAMBIO
    const selSupor = needsSupor ? $supor.value : ''; // === CAMBIO
    const selM2 = parseInt($m2.value,10);

    // === CAMBIO: si no se requiere soporte, ignorar soporteGroup en la búsqueda
    let match = DATA.find(x =>
      x.superficie === selSup &&
      x.m2 === selM2 &&
      (selEsp ? x.espacio === selEsp : true) &&
      (needsSupor ? x.soporteGroup === selSupor : true)
    );

    // fallback a "otro" si no existe específico para baño/cocina
    if (!match && selEsp && selEsp!=='otro') {
      match = DATA.find(x =>
        x.superficie === selSup &&
        x.m2 === selM2 &&
        x.espacio === 'otro' &&
        (needsSupor ? x.soporteGroup === selSupor : true)
      );
    }

    if (match) {
      window.location.href = match.url;
    } else {
      $hint.hidden = false;
    }
  });

  // init
  updateEspacio();
  updateSoporte();
  updateM2();
  validate();

});